import React, { useState } from "react";
import { Img } from "./Img";
import { usePetFiles } from "../../../hooks/uploads/usePetFiles";
import { Button, Typography } from "@mui/material";
import FileSelectorDialog from "../../common/forms/FileSelectorDialog";
import { useUploadFile } from "../../../hooks/uploads/useUploadFile";
import { useSnackbar } from "../../../context/SnackbarContext";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ImageGallery from "../../common/modals/ImageGallery";
import { timeAgo } from "../../../utils/timeAgo";

export function ProfilePicture({ pet }) {
    const { t } = useTranslation('common');
    const { showSnackbar } = useSnackbar();

    const [galleryOpen, setGalleryOpen] = useState(false);

    const [fileSelectorDialogOpen, setFileSelectorDialogOpen] = React.useState(false);
    const onFileSelectorClose = () => {
        setFileSelectorDialogOpen(false);
    };

    const [trigger, setTrigger] = React.useState(false);
    // Toggle function
    const toggleTrigger = () => {
        setTrigger(prev => !prev);
    };

    const { petFiles, loading } = usePetFiles(pet.id, {
        page: 0,
        limit: 0,
        tags: "profilePicture",
        trigger
    });

    const [tags, setTags] = useState(["profilePicture"]);

    const onFileUploadSuccess = () => {
        showSnackbar(t('files.messages.upload_success'), "success");
        toggleTrigger();
    };

    const { upload, progress } = useUploadFile(onFileUploadSuccess);
    
    const handleUploadPicture = async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("tags", JSON.stringify(tags));
        try {
            await upload(pet.id, formData);
        } catch (error) {
            if (error.status === 415)
            {
                showSnackbar(t("files.messages.unsupported_file_type"), "error");
            }
            else if (error.status === 414)
            {
                showSnackbar(t("files.messages.file_quota_exceeded"), "error");
            }
            else if (error.status === 413)
            {
                showSnackbar(t("files.messages.file_too_large"), "error");
            }
            else {
                showSnackbar(t("files.messages.upload_failed"), "error");
            }
        }
    };

    return (
        <>
        <Stack spacing={1}>
        { petFiles && petFiles.data && petFiles.data.length > 0 ? 
            <>
            <Box
                sx={{
                position: 'relative', // parent must be relative for absolute children
                borderRadius: 2,
                overflow: 'hidden', // Ensures the image inside is clipped
                display: 'inline-block', // keeps Box sized to its content
                boxShadow: 8
                }}
            >
                <Img 
                fileId={petFiles.data[0].id} 
                ratio="16:9" 
                alt="Pet photo" 
                />
                <Typography 
                  variant="caption"
                  sx={{
                      position: 'absolute',
                      bottom: 30,
                      left: 8,
                      bgcolor: 'rgba(0,0,0,0.3)',
                      color: 'white',
                      px: 1,
                      borderRadius: 1,
                  }}
                  noWrap={true}>
                    {petFiles.data[0].filename}
                </Typography>
                <Typography 
                  variant='caption' 
                  sx={{
                      position: 'absolute',
                      bottom: 8,
                      left: 8,
                      bgcolor: 'rgba(0,0,0,0.3)',
                      color: 'white',
                      px: 1,
                      borderRadius: 1,
                  }} 
                  noWrap={true}>
                    {`uploaded ${timeAgo(petFiles.data[0].createdAt)}`}
                </Typography>
            </Box>
            </>

        : null }
        <Button
            onClick={() => setFileSelectorDialogOpen(true)}
            variant="outlined"
            component="label"
            fullWidth
        >
            Upload Picture
        </Button>
        {petFiles?.data?.length > 0 ? 
        <Button
            onClick={() => setGalleryOpen(true)}
            variant="outlined"
            component="label"
            fullWidth
        >
            View Gallery
        </Button>
        : null }
        </Stack>
        <FileSelectorDialog 
            fileType='image'
            open={fileSelectorDialogOpen}
            onClose={onFileSelectorClose}
            onSubmit={handleUploadPicture}
            progress={progress}
            showRecordVoice={false}
        />
        <ImageGallery 
          pet={pet}
          open={galleryOpen}
          onClose={() => {
            setGalleryOpen(false);
            toggleTrigger();
          }}
        />
        </>
    );
}